import { useState } from 'react';
import { useSetAtom } from 'jotai';
import { RESET } from 'jotai/utils';
import { REVIEW_ACTION_TYPE } from '../../../../common/review-action/constants';
import { TASK_MODE } from '../../../../common/task-state/constants';
import useTaskStateStore from '../../../../common/task-state/providers/hooks/useTaskStateStore';
import { drawerAtom } from '../../atoms/drawer.atom';
import { SIDE_PANEL_ACTIONS } from '../../const';
import { useDispatch } from '../../hooks/use-dispatch';
import type { ModernizedGenericAnnotation } from '../../types';
type PropsT = {
  annotations: ModernizedGenericAnnotation[];
};
export function useImportHandlers({
  annotations
}: PropsT) {
  const [checkedAnnotationIds, setCheckedAnnotationIds] = useState<string[]>([]);
  const dispatch = useDispatch();
  const {
    hasRequiredTaskMode
  } = useTaskStateStore();
  const setDrawer = useSetAtom(drawerAtom);
  const handleCheckAnnotation = (id: string) => {
    setCheckedAnnotationIds(prev => {
      if (prev.includes(id)) {
        return prev.filter(prevId => prevId !== id);
      }
      return [...prev, id];
    });
  };
  const handleSelectAll = () => {
    setCheckedAnnotationIds(annotations.map(annotation => annotation.id));
  };
  const handleImport = () => {
    const isReviewMode = hasRequiredTaskMode(TASK_MODE.REVIEW);
    const isRejectedMode = hasRequiredTaskMode(TASK_MODE.REJECTED);
    const reviewAction = isRejectedMode || isReviewMode ? REVIEW_ACTION_TYPE.PENDING : undefined;
    dispatch({
      type: SIDE_PANEL_ACTIONS.IMPORT_ML_ANNOTATIONS,
      annotationIdList: checkedAnnotationIds,
      reviewAction
    });
    setDrawer(RESET);
  };
  return {
    checkedAnnotationIds,
    handleCheckAnnotation,
    handleSelectAll,
    handleImport
  };
}